$(function () {
	$('input.datetime').datetimepicker();

	$('input.date').datetimepicker({
		format: 'L'
	});

	$('input.time').datetimepicker({
		format: 'LT'
	});

	$('[data-start-date-id]').on('dp.change', function (e: any) {
		$('[data-end-date-id="' + $(this).data('start-date-id') + '"]').data('DateTimePicker').minDate(e.date);
	});

	$('[data-end-date-id]').on('dp.change', function (e: any) {
		$('[data-start-date-id="' + $(this).data('end-date-id') + '"]').data('DateTimePicker').maxDate(e.date);
	});

	$("div.alert[data-hash]").on("closed.bs.alert", event => {
		$.post("/home/dismiss-alert", {
			hash: $(event.currentTarget).data("hash")
		});
	});
});
